/* Keep the chosen controls and the successfully rendered preview in sync. */
(function (root) {
  function createMosafyPreviewState(initial, state = {}) {
    const valid = value => ['low', 'medium', 'high'].includes(value);
    const hasKnownSettings = valid(initial.opacity) && valid(initial.randomness);
    const model = {
      selectedOpacity: valid(initial.opacity) ? initial.opacity : 'high',
      selectedBestK: valid(initial.randomness) ? initial.randomness : 'high',
      appliedOpacity: hasKnownSettings ? initial.opacity : null,
      appliedBestK: hasKnownSettings ? initial.randomness : null,
      regenerating: false,
      previewError: false,
      previewUpdated: false,
      imageTimestamp: Date.now(),
      get hasPendingChanges() {
        return this.selectedOpacity !== this.appliedOpacity || this.selectedBestK !== this.appliedBestK;
      },
      get canContinuePreview() {
        return !this.regenerating && !this.hasPendingChanges && !this.previewError;
      },
      get sessionUrl() {
        return `${window.MOSAIC_API}/sessions/${initial.sessionId}/output.jpg?t=${this.imageTimestamp}`;
      },
      initPreviewState() {
        for (const key of ['selectedOpacity', 'selectedBestK']) {
          this.$watch(key, () => { this.previewUpdated = false; });
        }
      },
      continueFromPreview() {
        if (!this.canContinuePreview) return;
        this.doneGenerating = true;
        this.showModal2 = false;
        this.showModal1 = false;
      },
      async regenerate() {
        if (this.regenerating) return;
        this.regenerating = true;
        this.previewError = false;
        this.previewUpdated = false;
        const opacity = this.selectedOpacity;
        const randomness = this.selectedBestK;
        try {
          const response = await fetch(`${window.MOSAIC_API}/generate`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              sessionId: initial.sessionId,
              paperSize: 'A4',
              landscape: initial.landscape,
              bestK: this.mosaicConfig?.bestKLevels?.[randomness] ?? ({low: 8, medium: 15, high: 50})[randomness],
              opacity: this.mosaicConfig?.opacityLevels?.[opacity] ?? ({low: .45, medium: .55, high: .65})[opacity],
            }),
          });
          if (!response.ok) throw new Error('Mosaic generation failed');
          await response.json();
          const timestamp = Date.now();
          const source = `${window.MOSAIC_API}/sessions/${initial.sessionId}/output.jpg?t=${timestamp}`;
          // Do not unlock Continue until the new image is actually available.
          await new Promise((resolve, reject) => {
            const preview = new Image();
            const timer = setTimeout(() => finish(new Error('Preview loading timed out')), 20000);
            function finish(error) {
              clearTimeout(timer);
              preview.onload = preview.onerror = null;
              if (error) reject(error); else resolve();
            }
            preview.onload = () => finish();
            preview.onerror = () => finish(new Error('Preview could not be loaded'));
            preview.src = source;
          });
          this.imageTimestamp = timestamp;
          this.appliedOpacity = opacity;
          this.appliedBestK = randomness;
          const url = new URL(window.location.href);
          url.searchParams.set('randomness', randomness);
          url.searchParams.set('opacity', opacity);
          window.history.replaceState({}, '', url);
          this.previewUpdated = true;
        } catch (error) {
          this.previewError = true;
          console.error('Mosaic preview update failed:', error);
        } finally {
          this.regenerating = false;
        }
      },
    };
    return Object.defineProperties(state, Object.getOwnPropertyDescriptors(model));
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = createMosafyPreviewState;
  else root.createMosafyPreviewState = createMosafyPreviewState;
})(typeof window !== 'undefined' ? window : globalThis);
